import _isNil from 'lodash/isNil';
import { Accept } from 'react-dropzone';

export enum FileType {
    CSV,
    JPG,
    PNG,
    SVG,
    GIF,
}

export const getFileTypeMimeObject = (types: Array<FileType>): Accept => {
    const output: Accept = {};

    const appendType = (type: FileType) => {
        switch (type) {
            case FileType.CSV:
                output['text/csv'] = ['.csv'];
                break;
            case FileType.JPG:
                output['image/jpeg'] = ['.jpg', '.jpeg'];
                break;
            case FileType.PNG:
                output['image/png'] = ['.png'];
                break;
            case FileType.SVG:
                output['image/svg+xml'] = ['.svg'];
                break;
            case FileType.GIF:
                output['image/gif'] = ['.gif'];
                break;
        }
    };

    types.forEach((t) => appendType(t));

    return output;
};
